"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const UserInfoAvatar_1 = require("@Components/UserInfoAvatar");
const Button_1 = require("@Components/Buttons/Button");
const SubmitButton_1 = __importDefault(require("@App/kit/fields/SubmitButton"));
const react_1 = __importDefault(require("react"));
const TopSection = (props) => {
    const { startedProfileInfo, setNonEditable, disabled } = props;
    return (react_1.default.createElement("div", { className: "profile-info" },
        react_1.default.createElement(UserInfoAvatar_1.UserInfoAvatar, { userInfo: startedProfileInfo }),
        react_1.default.createElement("div", { className: 'edit-buttons' },
            react_1.default.createElement(Button_1.Button, { mainColor: false, type: 'primary', onClick: setNonEditable }, "Cancel"),
            react_1.default.createElement(SubmitButton_1.default, { label: "Save", disabled: disabled }))));
};
exports.default = TopSection;
